import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    loading: false,
    submitting: false,
    tickets: [],
    totalCount: 0,
    statusCounts: { open: 0, in_progress: 0, resolved: 0 },
    currentTicket: null,
    error: "",
    comments: [],
    commentsLoading: false,
    unseenCount: 0,
}

const ticketingSlice = createSlice({
    name: "ticketing",
    initialState,
    reducers: {
        updateTickets: (state, action) => {
            state.tickets = (action.payload || []).map(t => ({
                ...t,
                status: t.status ?? "open",
            }))
        },
        updateTotalCount: (state, action) => {
            state.totalCount = action.payload
        },
        updateStatusCounts: (state, action) => {
            state.statusCounts = action.payload
        },
        updateCurrentTicket: (state, action) => {
            state.currentTicket = action.payload
        },
        updateTicketingLoading: (state, action) => {
            state.loading = action.payload
        },
        updateTicketSubmitting: (state, action) => {
            state.submitting = action.payload
        },
        updateTicketError: (state, action) => {
            state.error = action.payload
        },
        updateComments: (state, action) => {
            state.comments = action.payload
        },
        updateCommentsLoading: (state, action) => {
            state.commentsLoading = action.payload
        },
        updateUnseenCount: (state, action) => {
            state.unseenCount = action.payload
        },
    },
})

export const {
    updateTickets,
    updateTotalCount,
    updateStatusCounts,
    updateCurrentTicket,
    updateTicketingLoading,
    updateTicketSubmitting,
    updateTicketError,
    updateComments,
    updateCommentsLoading,
    updateUnseenCount,
} = ticketingSlice.actions

export default ticketingSlice.reducer
